import { render, staticRenderFns } from "./strategies.view.vue?vue&type=template&id=250b0e54&scoped=true&"
import script from "./strategies.view.vue?vue&type=script&lang=ts&"
export * from "./strategies.view.vue?vue&type=script&lang=ts&"
import style0 from "./strategies.view.vue?vue&type=style&index=0&id=250b0e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b0e54",
  null
  
)

export default component.exports